import { render } from "./CancelledOrders.vue?vue&type=template&id=16a2e344&scoped=true"
import script from "./CancelledOrders.vue?vue&type=script&lang=js"
export * from "./CancelledOrders.vue?vue&type=script&lang=js"

import "./CancelledOrders.vue?vue&type=style&index=0&id=16a2e344&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a2e344"]])

export default __exports__